import React from 'react';
import { FadeIn } from './FadeIn';
import { Lock, Download, Smartphone } from 'lucide-react';
export function PriceAndCTA() {
  return <section id="pricing" className="bg-white py-12 md:py-16 px-4 sm:px-6 lg:px-8" data-id="element-81">
      <div className="max-w-4xl mx-auto text-center" data-id="element-82">
        <FadeIn data-id="element-83">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-black mb-8" data-id="element-84">
            Your Investment Today:
          </h2>
        </FadeIn>

        {/* Discount badge */}
        <FadeIn delay={0.15} data-id="element-85">
          <div className="mb-8" data-id="element-86">
            <span className="inline-block text-white font-bold text-sm md:text-base px-6 py-2 rounded-full" style={{
            backgroundColor: '#E63946'
          }} data-id="element-87">
              🔥 79% OFF — LIMITED TIME
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-88">
          {/* Crossed out price */}
          <div className="mb-2" data-id="element-89">
            <span className="font-bold line-through" style={{
            fontSize: '28px',
            color: '#E63946'
          }} data-id="element-90">
              $34
            </span>
          </div>
          <p className="text-sm text-gray-400 italic mb-6" data-id="element-91">(Regular Price)</p>

          {/* Main price */}
          <p className="uppercase tracking-widest font-semibold text-sm mb-1" style={{
          color: '#C9A84C'
        }} data-id="element-92">
            Today Only:
          </p>
          <p className="font-black leading-none mb-2" style={{
          fontSize: '96px',
          color: '#2F4F4F',
          textShadow: '0 0 40px rgba(201, 168, 76, 0.3)'
        }} data-id="element-93">
            $7
          </p>
          <p className="text-gray-500 text-sm mb-8" data-id="element-94">
            One-time payment. No subscriptions. Ever.
          </p>

          {/* Savings callout */}
          <div className="inline-block mb-10" data-id="element-95">
            <div className="px-8 py-3 rounded-lg font-bold text-forest-green text-lg" style={{
            border: '2px solid #C9A84C',
            backgroundColor: 'rgba(201, 168, 76, 0.1)'
          }} data-id="element-96">
              Get $34 worth of value for just $7 today
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-97">
          <a href="#urgency-close" className="inline-block w-full md:w-auto bg-sage-green hover:bg-forest-green text-white text-xl md:text-2xl font-bold py-6 px-8 rounded-full transition-all duration-300 transform hover:scale-105 shadow-xl hover:shadow-2xl" data-id="element-98">
            👆 I WANT TO DOWNLOAD MY COPY NOW FOR JUST $7
          </a>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-99">
          <div className="mt-10 flex flex-col md:flex-row items-center justify-center gap-6 text-sm text-gray-500 font-medium" data-id="element-100">
            <div className="flex items-center gap-2" data-id="element-101">
              <Lock className="w-5 h-5 text-gray-400" data-id="element-102" />
              <span data-id="element-103">Secure payment processed by Stripe or PayPal</span>
            </div>
            <div className="hidden md:block w-1 h-1 bg-gray-300 rounded-full" data-id="element-104"></div>
            <div className="flex items-center gap-2" data-id="element-105">
              <Download className="w-5 h-5 text-gray-400" data-id="element-106" />
              <span data-id="element-107">Immediate access after payment</span>
            </div>
            <div className="hidden md:block w-1 h-1 bg-gray-300 rounded-full" data-id="element-108"></div>
            <div className="flex items-center gap-2" data-id="element-109">
              <Smartphone className="w-5 h-5 text-gray-400" data-id="element-110" />
              <span data-id="element-111">Available in PDF for any device</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}